// --- Swiper import & init ---

// Settings: https://swiperjs.com/get-started/

import SwiperCore, {
    Navigation,
    Pagination,
} from 'swiper/core';

SwiperCore.use([
    Navigation,
    Pagination,
]);

var swiperSettings = {

    centeredSlides: true,
    spaceBetween: 15,
    allowTouchMove: false,
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    pagination: {
        el: '.swiper-pagination',
        renderBullet: function (index, className) {
            return '<span class="' + className + '">' + (index + 1) + "</span>";
        },
    }
};

const swiper = new SwiperCore('.swiper-container', swiperSettings);


// --- Customizer ---

var customizer = document.getElementById('customizer');

var nextButtons = document.querySelectorAll('.swiper-button-next');

function activateNextButton() {

    customizer.querySelector('.complete-box').classList.add('d-none');
    customizer.querySelector('.error-box').classList.add('d-none');

    nextButtons.forEach(function (nextButton) {  
        nextButton.classList.add('swiper-button-disabled');
    });

    if (customizer.getAttribute('data-step-1')) {
        nextButtons[0].classList.remove('swiper-button-disabled');
    }

    if (customizer.getAttribute('data-step-2')) {
        nextButtons[1].classList.remove('swiper-button-disabled');
    }

    if (customizer.getAttribute('data-step-3')) {
        nextButtons[2].classList.remove('swiper-button-disabled');
    }

    if (customizer.getAttribute('data-step-4-color') && customizer.getAttribute('data-step-4-name')) {
        nextButtons[3].classList.remove('swiper-button-disabled');
    }

}

nextButtons[0].classList.add('swiper-button-disabled');

swiper.on('slideChange', activateNextButton);


// --- Step 1 ---

var step1options = document.querySelectorAll('#customizer-step-1 .option');
var step1descriptions = document.querySelectorAll('#customizer-step-1 .description');

step1options.forEach(function (option) {     
    
    option.addEventListener('click', function () {

        // remove 'active' class from all items

        var step1all = [];
        step1all.push.apply(step1all, step1options);
        step1all.push.apply(step1all, step1descriptions);
        
        step1all.forEach( function(el) {
            el.classList.remove('active');
        });

        // add 'active' class to current item

        option.classList.add('active');

        // add 'active' class to description item

        var currentIndex = Array.prototype.indexOf.call(step1options, option);

        option.classList.contains('active') ? step1descriptions[currentIndex].classList.add('active') : null;
    
        // set step value to customizer

        customizer.setAttribute('data-step-1', option.getAttribute('data-step-1'));

        // enable next button
        
        activateNextButton();

    });
    
});

// --- Step 2 ---

var step2options = document.querySelectorAll('#customizer-step-2 .option');
var step2descriptions = document.querySelectorAll('#customizer-step-2 .description');

step2options.forEach(function (option) {     
    
    option.addEventListener('click', function () {

        // remove 'active' class from all items

        var step2all = [];
        step2all.push.apply(step2all, step2options);
        step2all.push.apply(step2all, step2descriptions);
        
        step2all.forEach( function(el) {
            el.classList.remove('active');
        });

        // add 'active' class to current item

        option.classList.add('active');

        // add 'active' class to description item

        var currentIndex = Array.prototype.indexOf.call(step2options, option);

        option.classList.contains('active') ? step2descriptions[currentIndex].classList.add('active') : null;
    
        // set step value to customizer

        customizer.setAttribute('data-step-2', option.getAttribute('data-step-2'));

        // enable next button

        activateNextButton();

    });
    
});

// --- Step 3 ---

var step3options = document.querySelectorAll('#customizer-step-3 .option');
var step3descriptions = document.querySelectorAll('#customizer-step-3 .description');
var step3selections = document.querySelectorAll('#customizer-step-3 .selections li');

step3options.forEach(function (option) {     
    
    option.addEventListener('click', function () {

        // remove 'active' class from all items

        var step3all = [];
        step3all.push.apply(step3all, step3options);
        step3all.push.apply(step3all, step3descriptions);
        step3all.push.apply(step3all, step3selections);
        
        step3all.forEach( function(el) {
            el.classList.remove('active');
        });

        // add 'active' class to current item

        option.classList.add('active');

        // add 'active' class to description item

        var currentIndex = Array.prototype.indexOf.call(step3options, option);

        option.classList.contains('active') ? step3descriptions[currentIndex].classList.add('active') : null;
    
        // remove step value to customizer

        customizer.setAttribute('data-step-3', '');

        // set step value to step 5 package

        document.querySelector('.package-category').innerHTML = document.querySelector('#customizer-step-3 .description.active h3').innerHTML;

        // enable next button

        activateNextButton();

    });
    
});

step3selections.forEach(function (selection) {     
    
    selection.addEventListener('click', function () {

        // remove 'active' class from all selections items

        step3selections.forEach( function(el) {
            el.classList.remove('active');
        });

        // add 'active' class to current item

        selection.classList.add('active');
   
        // set step value to customizer

        customizer.setAttribute('data-step-3', selection.getAttribute('data-step-3'));

        // set step value to step 5 package

        document.querySelector('.package-type').innerHTML = selection.querySelector('span').innerHTML;

        // enable next button

        activateNextButton();

    });
    
});

// --- Step 4 ---

var step4colors = document.querySelectorAll('#customizer-step-4-color .color');
var step4name = document.querySelector('#customizer-step-4-name .name');

step4colors.forEach(function (color) {     
    
    color.addEventListener('click', function () {

        // remove 'active' class from all color items

        step4colors.forEach( function(el) {
            el.classList.remove('active');
        });

        // add 'active' class to current item

        color.classList.add('active');
    
        // set step value to customizer

        customizer.setAttribute('data-step-4-color', color.getAttribute('data-step-4-color'));
        customizer.setAttribute('data-step-4-color-hex', color.getAttribute('data-step-4-color-hex'));

        // enable next button

        activateNextButton();

    });
    
});

step4name.addEventListener('input', function () {

    // set step value to customizer

    customizer.setAttribute('data-step-4-name', step4name.value);

    // set step value to package

    document.querySelector('.package-name').innerHTML = step4name.value;

    // enable next button

    activateNextButton();

});

nextButtons[3].addEventListener('click', function () {

    // price data object

    var sendPriceData = {
        action: 'custom_woocommerce_ajax_get_product_price',
        sku: customizer.getAttribute('data-step-1') +
             customizer.getAttribute('data-step-2') +
             customizer.getAttribute('data-step-3') +
             customizer.getAttribute('data-step-4-color'),
        category_coffe: document.querySelector('.package-category').innerHTML,
    }

    // console.log(sendPriceData);

    jQuery(document).ready(function($) {

        $.ajax({
            type: 'post',
            url: "/wp-admin/admin-ajax.php",
            data: sendPriceData,
            complete: function(response) { 
                // console.log('complete')
            },
            success: function(response) {
                // console.log(response)
                document.querySelector('.customizer-price .price span').innerHTML = '€ ' + response.price;
                document.querySelector('.package-label-inner .bottom-right span').innerHTML = response.short_description;
                $("#customizer-add-to-cart").prop("disabled", false);
                customizer.querySelector('.error-box').classList.add('d-none');
            },
            error: function(response) {
                document.querySelector('.customizer-price .price span').innerHTML = '€ -.--';
                $("#customizer-add-to-cart").prop("disabled", true);
                customizer.querySelector('.error-box').classList.remove('d-none');
            }
        })
        
    })

});

// --- Step 5 ---

var step5quantity = document.querySelector('#customizer-quantity');
var step5addtocart = document.querySelector('#customizer-add-to-cart');

step5addtocart.addEventListener('click', function () {

    // customizer data object

    var customizerData = {
        action: 'custom_woocommerce_ajax_add_to_cart',
        sku: customizer.getAttribute('data-step-1') +
             customizer.getAttribute('data-step-2') +
             customizer.getAttribute('data-step-3') +
             customizer.getAttribute('data-step-4-color'),
        label: customizer.getAttribute('data-step-4-name'),
        quantity: parseInt(step5quantity.value),
        category_coffe: document.querySelector('.package-category').innerHTML,
        type_coffe: document.querySelector('.package-type').innerHTML,
        color_hex: customizer.getAttribute('data-step-4-color-hex'),
    }

    // console.log(customizerData)

    jQuery(document).ready(function($) {

        $.ajax({
            type: 'post',
            url: "/wp-admin/admin-ajax.php",
            data: customizerData,
            complete: function(response) { 
                // console.log('complete')
            },
            success: function(response) {
                console.log(response)
                customizer.querySelector('.complete-box').classList.remove('d-none');
                customizer.querySelector('.error-box').classList.add('d-none');
            },
            error: function(response) {
                customizer.querySelector('.error-box').classList.remove('d-none');
                customizer.querySelector('.complete-box').classList.add('d-none');
            }
        })
        
    })

});